import React from 'react';
import classNames from 'classnames';
import SerializedRow from 'Utils/SerializedRow';

class SerializedInventoryTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      usageDir: true,
    };
  }

  changeColumnDirection = (name) => {
    this.setState((prevState) => ({
      [name]: !prevState[name],
    }));
  };

  render() {
    const {
      updateSelected,
      checkSelected,
      unitsAvailable,
      isCheckIn,
      serializedProducts,
      serialNumbers,
      sortBySelected,
      lastScannedSerial,
    } = this.props;
    const { usageDir } = this.state;
    const showUsage = serializedProducts[0]?.usageWithUnitDetails?.length > 0;

    // Restrict the check-in list to the serials that belong to this pick list
    // item. We key off the item's serial_numbers (which include both still-out
    // and already-returned units) rather than the SerializedPickListItem
    // status: once a serial is checked in the backend flips that status to
    // 'checked_in', and filtering on 'in_use' made checked-in serials vanish
    // from the modal on reopen, leaving no way to view or edit them (TD1-9961).
    const filteredSerializedProducts = !!isCheckIn
      ? serializedProducts?.filter((product) =>
          serialNumbers?.includes(product.token)
        )
      : serializedProducts;
    return (
      <table
        className={classNames({
          grid: true,
          checkInUsage: isCheckIn,
        })}
      >
        <thead>
          <tr>
            <th>
              <span
                className={classNames('padding-bottom-10', {
                  sortable: !!sortBySelected,
                  asc: true,
                })}
                onClick={sortBySelected}
              />
            </th>
            <th>Serial No</th>
            {showUsage && (
              <th>
                <span
                  className={classNames({
                    sortable: true,
                    asc: usageDir,
                    desc: !usageDir,
                  })}
                  onClick={() => {
                    this.changeColumnDirection('usageDir');
                  }}
                >
                  Usage
                </span>
              </th>
            )}
            {showUsage && <th>Usage Out</th>}
            {!!isCheckIn && !!unitsAvailable && <th>Date</th>}
            {!!isCheckIn && !!unitsAvailable && <th>Units In</th>}
          </tr>
        </thead>
        <tbody>
          {!!isCheckIn
            ? filteredSerializedProducts.map((serializedProduct) =>
                Array.isArray(serializedProduct.checkIn) &&
                serializedProduct.checkIn.length > 0 ? (
                  serializedProduct.checkIn.map((checkIn, index) => (
                    <SerializedRow
                      serializedProduct={serializedProduct}
                      index={index}
                      checkObj={checkIn}
                      updateSelected={updateSelected}
                      checkSelected={checkSelected}
                      isScannedItem={serializedProduct.serialNumber === lastScannedSerial}
                    />
                  ))
                ) : (
                  <SerializedRow
                    serializedProduct={serializedProduct}
                    index={0}
                    updateSelected={updateSelected}
                    checkSelected={checkSelected}
                    isScannedItem={serializedProduct.serialNumber === lastScannedSerial}
                  />
                )
              )
            : filteredSerializedProducts.map((serializedProduct) =>
                Array.isArray(serializedProduct.checkOut) &&
                serializedProduct.checkOut.length > 0 ? (
                  serializedProduct.checkOut.map((checkOut, index) => (
                    <SerializedRow
                      serializedProduct={serializedProduct}
                      index={index}
                      checkObj={checkOut}
                      updateSelected={updateSelected}
                      checkSelected={checkSelected}
                      isScannedItem={serializedProduct.serialNumber === lastScannedSerial}
                    />
                  ))
                ) : (
                  <SerializedRow
                    serializedProduct={serializedProduct}
                    index={0}
                    updateSelected={updateSelected}
                    checkSelected={checkSelected}
                    isScannedItem={serializedProduct.serialNumber === lastScannedSerial}
                  />
                )
              )}
        </tbody>
      </table>
    );
  }
}

export default SerializedInventoryTable;
